import { useUserState } from "../../../context/UserContext";
import {
  Card, CardActionArea, Tooltip,
  Grid
} from "@mui/material";
import Templateimg1 from "../../../assets/images/template1.png";
import Templateimg2 from "../../../assets/images/template2.png";
import Templateimg3 from "../../../assets/images/template3.png";
import Template1 from "../Template/SessionTemplate";
import Template2 from "../Template/SessionTemplate2";
import Template3 from "../Template/SessionTemplate3";
import { useEffect, useState } from "react";
import useStyles from "../styles";
import { Icon } from "@iconify/react/dist/iconify.js";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
// import PageLoader from "../../../components/PageLoader";

const PROFILE_ENDPOINT = "/api/v1/profile";

const SessionReportTemplate = ({ isMobile, onTemplatePreview, handleTemplateModal, templateModal }) => {
  const { profile, appLogo, subscription } = useUserState();
  const [selectedId, setSelectedId] = useState("");
  const classes = useStyles();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [templateToConfirm, setTemplateToConfirm] = useState(null);
  const subscriptionName = subscription?.pricing_plan?.name;
  const [isLoading, setIsLoading] = useState(false);

  const allTerms = [
    { id: "term1", name: "1st Term" },
    { id: "term2", name: "2nd Term" },
    { id: "term3", name: "3rd Term" }
  ];

  useEffect(() => {
    if (profile?.report_template?.template_id) {
      setSelectedId(profile.report_template.template_id);
    }
  }, [profile]);

  const scores = [
    {
      subject: "Mathematics",
      termScores: {
        term1: 85,
        term2: 78,
        term3: 90
      },
      average: 84.3,
      grade: "A"
    },
    {
      subject: "English Language",
      termScores: {
        term1: 72,
        term2: 80,
        term3: 76
      },
      average: 76.0,
      grade: "B"
    },
    {
      subject: "Basic Science",
      termScores: {
        term1: 88,
        term2: 85,
        term3: 82
      },
      average: 85.0,
      grade: "A"
    },
    {
      subject: "Civic Education",
      termScores: {
        term1: 90,
        term2: 87,
        term3: 92
      },
      average: 89.7,
      grade: "A"
    }
  ];

  const attendance = [
    {
      term_id: 1,
      term: "First Term",
      total_days: 90,
      days_present: 85,
      days_absent: 5
    },
    {
      term_id: 2,
      term: "Second Term",
      total_days: 88,
      days_present: 80,
      days_absent: 8
    },
    {
      term_id: 3,
      term: "Third Term",
      total_days: 92,
      days_present: 89,
      days_absent: 3
    }
  ];

  const comment = "Jane is a bright student who consistently puts in her best effort. She is promoted to the next class.";

  const handleSelect = (template) => {
    if (!template.locked) {
      if (isMobile) {
        onTemplatePreview(template);
      } else {
        setTemplateToConfirm(template);
        setConfirmationModalOpen(true);
      }
    }
  };
  const templates = [
    {
      id: "template-1",
      name: "Template 1",
      version: "1.0",
      image: Templateimg1,
      locked: false,
      component: Template1
    },
    {
      id: "template-2",
      name: "Template 2",
      version: "1.0",
      image: Templateimg2,
      locked: !["Pro", "Partner"].includes(subscriptionName),
      component: Template2
    },
    {
      id: "template-3",
      name: "Template 3",
      version: "1.0",
      image: Templateimg3,
      locked: !["Pro", "Partner"].includes(subscriptionName),
      component: Template3
    }
  ];

  const confirmTemplateSelection = () => {
    if (templateToConfirm) {
      setSelectedId(templateToConfirm.id);
      setConfirmationModalOpen(false);

      const templateData = {
        report_template: {
          template_id: templateToConfirm.id,
          version: templateToConfirm.version
        }
      };

      setIsLoading(true);
      httprequest
        .patch(PROFILE_ENDPOINT, templateData)
        .then((res) => {
          toast.success(res?.data?.message || "Template updated successfully");
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        })
        .catch((err) => {
          toast.error(err?.response?.message || "Failed to update template");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const currentTemplate = templates.find(t => t.id === selectedId)?.component || Template1;

  return (
    <Grid container spacing={4} className="margin-top-16">
      <Grid item lg={8} md={12} sm={12} xs={12}>
        {currentTemplate({
          profile,
          scores,
          allTerms,
          comment,
          attendance,
          appLogo
        })}
      </Grid>
      {!isMobile && (
        <Grid item lg={4} md={12} sm={12} xs={12}>
          <div className="right-container relative-full container-border template-right">
            <div className={classes.container}>
              <h3 className={classes.templatetitle}>Templates</h3>

              <Grid container spacing={1}>
                {templates.map((template) => (
                  <Grid item lg={6} md={6} sm={12} xs={12} key={template?.id}>
                    <div className={classes.mycards}>
                      <Tooltip title={template.locked ? "Upgrade to unlock" : ""}>
                        <Card
                          className={`${classes.card} ${selectedId === template.id ? classes.activeCard : ""} ${
                            template.locked ? classes.lockedCard : ""
                          }`}
                          onClick={() => handleSelect(template)}
                        >
                          <CardActionArea disabled={template.locked}>
                            <img src={template?.image} alt={template?.name} className={classes.image} />
                          </CardActionArea>
                        </Card>
                        <p className={classes.templateName}>{template?.name}</p>
                      </Tooltip>
                    </div>
                  </Grid>
                ))}
              </Grid>

              <div className={classes.locknote}>
                <div>
                  <Icon icon="solar:info-circle-linear" />
                </div>
                <p> Access locked templates when you upgrade to a pro account.</p>
              </div>
            </div>
          </div>
        </Grid>
      )}

      <Modal
        title="Select Template"
        subtitle="Choose your preferred report template"
        modalContent={
          <div className={classes.templateModalContent}>
            <Grid item lg={4} md={12} sm={12} xs={12}>
              <div className="right-container relative-full container-border">
                <div className={classes.container}>
                  <h3 className={classes.templatetitle}>Templates</h3>

                  <Grid container spacing={1}>
                    {templates.map((template) => (
                      <Grid item lg={6} md={4} sm={6} xs={12} key={template?.id}>
                        <div className={classes.mycards}>
                          <Tooltip title={template.locked ? "Upgrade to unlock" : ""}>
                            <Card
                              className={`${classes.card} ${selectedId === template.id ? classes.activeCard : ""} ${
                                template.locked ? classes.lockedCard : ""
                              }`}
                              onClick={() => !template.locked && onTemplatePreview(template)}
                            >
                              <CardActionArea disabled={template.locked}>
                                <img src={template?.image} alt={template?.name} className={classes.image} />
                              </CardActionArea>
                            </Card>
                            <p className={classes.templateName}>{template?.name}</p>
                          </Tooltip>
                        </div>
                      </Grid>
                    ))}
                  </Grid>

                  <div className={classes.locknote}>
                    <div>
                      <Icon icon="solar:info-circle-linear" />
                    </div>
                    <p> Access locked templates when you upgrade to a pro account.</p>
                  </div>
                </div>
              </div>
            </Grid>
          </div>
        }
        isopen={templateModal}
        closeModal={handleTemplateModal}
      />

      <Modal
        title="Set Default Template"
        subtitle={
          templateToConfirm ? (
            <div>
              Are you sure you want to set
              <span className="modal-name-highlight"> {templateToConfirm.name} v{templateToConfirm.version}</span>
              as your default report template?
            </div>
          ) : null
        }
        modalContent={<></>}
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primaryoutline"
                buttonSize="full"
                color="btnfontprimary"
                buttonName="Cancel"
                onClick={() => setConfirmationModalOpen(false)}
              />
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName={isLoading ? "Setting..." : "Set as Default"}
                onClick={confirmTemplateSelection}
                disabled={isLoading}
              />

            </div>
          </>
        }
        isopen={confirmationModalOpen}
        closeModal={() => setConfirmationModalOpen(false)}
      />
    </Grid>

  );
};

export default SessionReportTemplate;
